<template>
    <AirIcon v-if="isAirProduct" />
    <EurekaIcon v-else />
</template>
<script setup lang="ts">
import { ref, onMounted } from 'vue';
import AirIcon from './AirIcon.vue';
import EurekaIcon from './EurekaIcon.vue';
import { controlDeferred } from '@eureka/utils/control';

const isAirProduct = ref(false);

onMounted(async() => {
    const { is_air_product } = await controlDeferred.promise;
    isAirProduct.value = is_air_product;
});
</script>
